var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-tag-container"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("添加标签")]), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.handleClose(0)
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, _vm._l((_vm.selectData.list), function(item, index) {
    return _c('button', {
      staticClass: "btn",
      class: {
        'btn-active': index === _vm.selectData.activeTab
      },
      on: {
        "click": function($event) {
          _vm.handleButtonClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.tabName))])
  })), _vm._v(" "), _c('select-box', {
    attrs: {
      "data": _vm.selectData.list[_vm.selectData.activeTab],
      "total-select": _vm.selectData.totalSelect,
      "current-select": _vm.selectData.currentSelect
    },
    on: {
      "select-change": _vm.handleSelectChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('button', {
    staticClass: "btn footer-btn",
    on: {
      "click": function($event) {
        _vm.handleClose(0)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn footer-btn",
    on: {
      "click": function($event) {
        _vm.handleClose(1)
      }
    }
  }, [_vm._v("确定")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ce8f58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectTag.vue
// module id = mr7g
// module chunks = 1